import React from 'react';

import { PeopleIcon } from '@primer/octicons-react';

import BlankSlate from '../common/BlankSlate/BlankSlate';
import Icon from '../common/icons/Icon';

import { getThemeColor } from '../../utils/theme-utils';

const NoUsersGraphic = () => (
  <Icon
    fill={getThemeColor('brand')}
    icon={PeopleIcon}
    size={64}
  />
)

export const NoUsersSlate = ({ 
  mainText = "We couldn't find any users in this workspace." 
}) => (
  <BlankSlate
    className="p-4"
    mainText={mainText}
    Graphic={NoUsersGraphic}
  />
)

export default NoUsersSlate;
